/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledCustomRadio = styled.section`
  .container-custom-radio {
    display: flex;
    flex-direction: column;
    gap: 16px;
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    padding: 4px;
  }

 .label-radio {
   display: flex;
   align-items: flex-start;
   border-radius: 8px;
   padding: 16px;
   cursor: pointer;
 }
 
 .input-radio {
  margin-top: 4px;
  margin-right: 16px;
  height: 24px;
  width: 24px;
  min-width: 24px;
  min-width: 24px;
  border: 2px solid #646569;
  border-radius: 50%;
  appearance: none;
  -webkit-appearance: none;
  background-color: #fff;
  position: relative;
  cursor: pointer;
  outline: none;
}

.input-radio:checked::after {
    border: 2px solid #007DB7;
}

.input-radio:checked::before {
  content: '';
  position: absolute;
  top: 3.4px;
  left: 3.4px;
  width: 15px;
  height: 15px;
  background-color: #007DB7;
  border-radius: 50%;
  border: 2px solid #007DB7;
}
.div-title {
    font-weight:900;
    color:#383838;
    line-height:26px;
}
.div-subtitle{
  font-weight: 400;
  color: #383838;
}
`;
